<div class="header__shadow {{ SHADOW_INTERACTIVE_CLASS }}"></div>

<div class="header__inner">
    <div class="header__overlay" id="header__overlay"></div>
    <div
        class="header__desktop"
        [ngClass]="{
            'header__desktop--animated': isRendered(),
        }"
        data-application="header-desktop"
    >
        <website-header-v2-desktop-menu
            [primaryNavigation]="primaryNavigation()"
            [secondaryNavigation]="secondaryNavigation()"
            [languages]="languages()"
            [currentLocale]="currentLocale()"
            [theme]="layoutTheme()"
            (trialButtonClickEvent)="onOpenPopup()"
        ></website-header-v2-desktop-menu>
    </div>

    <div
        class="header__mobile"
        data-application="header-mobile"
        [ngClass]="{ 'header__mobile--animated': isRendered() }"
    >
        <div class="header__row">
            <website-header-v2-logo></website-header-v2-logo>
            <div class="header__buttons">
                @if (!headerViewService.hideRightSide && secondaryNavigation().mobileButtonSendText) {
                    <button
                        website-button-v3
                        class="header__extra-small-button header__trial-form-button--small"
                        [buttonStyleProperties]="buttonStyleProperties"
                        (click)="onOpenPopup()"
                    >
                        {{ secondaryNavigation().mobileButtonSendText }}
                    </button>
                }
                @if (!headerViewService.hideRightSide && secondaryNavigation().mobileButtonSendText) {
                    <button
                        website-button-v3
                        class="header__small-button header__trial-form-button--small"
                        [buttonStyleProperties]="{
                            size: 'small',
                            buttonColor: buttonStyleProperties.buttonColor,
                            outlineColor: buttonStyleProperties.outlineColor,
                        }"
                        (click)="onOpenPopup()"
                    >
                        {{ secondaryNavigation().mobileButtonSendText }}
                    </button>
                }
                @if (isKlaxoon && !headerViewService.hideRightSide) {
                    <div class="header__additional-mobile-navigation">
                        <website-language-selector-button
                            [locale]="headerService.klaxoonNextLocale"
                            [isDropdown]="false"
                            (languageSelectorClick)="headerService.changeKlaxoonLocale()"
                        ></website-language-selector-button>
                        <a
                            class="header-menu__link header-list__link header-menu__link"
                            data-application="login-button"
                            [href]="secondaryNavigation().login.url"
                            [innerHTML]="secondaryNavigation().login.title"
                        ></a>
                    </div>
                }
                @if (secondaryNavigation().bookDemo && !headerViewService.hideRightSide) {
                    <a
                        website-button-v3
                        link-target-detector
                        data-application="book-demo-link"
                        class="header__book-demo__btn"
                        [buttonStyleProperties]="buttonStyleProperties"
                        [href]="secondaryNavigation().bookDemo.url"
                    >
                        <span class="header__book-demo-text header__book-demo-text--desktop">{{
                            secondaryNavigation().bookDemo.title
                        }}</span>
                        <span class="header__book-demo-text header__book-demo-text--mobile">{{
                            secondaryNavigation().bookDemo.titleMobile
                        }}</span>
                    </a>
                }

                <button
                    class="header-nav-button"
                    (click)="toggleMobileNav()"
                    title="Toggle mobile navigation"
                    data-application="header-nav-button"
                >
                    <span class="header-nav-button__inner">
                        <span class="header-nav-button__bar"></span>
                    </span>
                </button>
            </div>
        </div>
    </div>

    <div class="header__popup" data-application="header-popup">
        <div class="header__popup-row">
            <website-header-v2-logo></website-header-v2-logo>
            <button class="header-nav-button" (click)="toggleMobileNav()" title="Toggle mobile navigation">
                <span class="header-nav-button__inner">
                    <span class="header-nav-button__bar"></span>
                </span>
            </button>
        </div>

        @defer (when isMobilePopupOpened(); prefetch on idle) {
            <website-header-v2-mobile-menu
                [isKlaxoon]="isKlaxoon"
                [primaryNavigation]="primaryNavigation()"
                [secondaryNavigation]="secondaryNavigation()"
                [languages]="languages()"
                [currentLocale]="currentLocale()"
                [theme]="layoutTheme()"
            ></website-header-v2-mobile-menu>
        } @error {}
    </div>
</div>
